<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl" persistent)
    v-card
      v-card-title.pa-4
        v-spacer 
        .text-xl.font-bold.ml-10 Edit reject reason
        v-spacer
        v-btn(icon @click="showDialog = false" color="primary" small)
          v-icon mdi-close
      v-divider

      v-card-text.pa-8.primary--text
        .text-md.font-semibold.mb-4 Edit the information below
        .text-sm.font-semibold.neutral500--text.mb-2 Reject reason
        v-text-field.round-xl(v-model="name" placeholder="Enter reject reason" outlined hide-details)
      v-divider

      v-card-actions.px-6.py-3
        v-btn.button-md.underline.ml-n4(@click="showDialog = false" color="primary" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md.white--text(@click="save" color="primary" depressed :loading="isLoading" :disabled="!name.trim().length") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditRejectReasonDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    reason: {
      type: Object,
      default: () => {}
    },
    rejectStatus: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    isLoading: false,
    name: ''
  }),
  mounted () {
    this.name = this.reason.name
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    save () {
      this.isLoading = true
      this.$axios.patch(`/connect/${this.company.slug}/statuses/${this.rejectStatus.id}/reasons/${this.reason.id}`, { name: this.name })
        .then(() => {
          this.showMessage(['success', 'Reject reason successfully updated'])
          this.showDialog = false
          this.$emit('updated')
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data[0]) {
            message = err.response.data[0]
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>